
export default function(o, onTogglePlay){

  var playLabel = o.util.getTranslation(o, 'play')

  var playDiv = o.component.button(o, playLabel, onTogglePlay, 'play', true)

  var click = function(type){
    if(o.store('storySubtitleType') == type){
      return
    } else {
      return function(){
        o.store('storySubtitleType',type)
        o.render(o)
      }
    }
  }

  var subsTitle = $('<div>')
  .html(o.util.getTranslation(o,'subtitles'))
  .css({
    margin: '0.3rem 0.2rem',
    display: 'inline-block',
  })

  var subsButtonOff = o.component.button(o, o.util.getTranslation(o,'off'),click('off'))
  var subsButtonDe = o.component.button(o, 'de', click('de'))
  var subsButtonEn = o.component.button(o, 'en', click('en'))
  var subsButtonFr = o.component.button(o, 'fr', click('fr'))
  var subsButtonRu = o.component.button(o, 'ру', click('ru'))

  var div = $('<div>')
  .css({
    textAlign: 'center',
    whiteSpace: 'nowrap',
    overflowY: 'auto',
    '-webkit-overflow-scrolling': 'touch',
    fontSize: o.fontSizeDef.s,
    padding: "0.7rem",
  })
  .append([
    subsTitle,
    subsButtonOff
    .css({
      margin: '0.3rem 0.2rem',
    }),
    subsButtonDe
    .css({
      margin: '0.3rem 0.2rem',
    }),
    subsButtonEn
    .css({
      margin: '0.3rem 0.2rem',
    }),
    subsButtonFr
    .css({
      margin: '0.3rem 0.2rem',
    }),
    subsButtonRu
    .css({
      margin: '0.3rem 0.2rem',
    }),
    o.component.spacer(o),
    playDiv,
  ])

  div.togglePlay = playDiv.toggle

  return div

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/views/story/footer/footer.js